var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PersonelIoInfoInDateListWeb"},[_c('v-data-table',{attrs:{"dense":"","disable-sort":true,"headers":_vm.headers,"items":_vm.list,"hide-default-footer":!_vm.pagination,"disable-pagination":!_vm.pagination,"footer-props":{
      'items-per-page-options': [5, 10, 15, 50, 100, -1],
      'items-per-page-text': _vm.$t('rowsPerPage'),
      'show-first-last-page': true,
    }},on:{"click:row":_vm.handleClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }